import React from 'react';
import { getStatusMessageIcon } from 'react/utils/chatUtils';
import PropTypes from 'prop-types';

const Message = ({
  message, nextMessage, previousMessage, loggedUserId
}) => {
  const messageType = String(message.get('type')).toLowerCase();

  if (messageType === 'alert') {
    return (
      <div key={message.get('id')} className="messageInfo">
        <p>
          {message.get('text')}
        </p>
      </div>
    );
  }

  if (messageType === 'text') {
    const className = message.get('from') === loggedUserId
      ? 'messageItemFromCurrentUser' : 'messageItemFromOtherUser';
    const isTheLast = (!nextMessage || nextMessage?.origin !== message.get('origin'))
        && 'true';
    const isTheFirstFromTheUser = !previousMessage
        || previousMessage?.fromName !== message.get('fromName')
        || (previousMessage?.fromName === message.get('fromName')
          && previousMessage?.needTranslation);

    return (
      <div
        key={message.get('id')}
        className={`${className} msg`}
        isthelast={isTheLast || 'false'}
      >
        {message.get('isFromOtherAttendance') && isTheFirstFromTheUser && (
          <div className="messageFromName">
            {message.get('fromName') || message.get('from')}
          </div>
        )}
        <div className="messageText">{message.get('text')}</div>
        <div className="messageHour">
          <span>{message.get('sentDate')}</span>
          {message.get('origin') === 'internal'
              && <img src={getStatusMessageIcon(message.toJS())} alt="Status image" />}
        </div>
      </div>
    );
  }

  return <></>;
};

Message.propTypes = {
  message: PropTypes.object.isRequired,
  nextMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  loggedUserId: PropTypes.number.isRequired
};

Message.defaultProps = {
  nextMessage: null,
  previousMessage: null
};

export default Message;
